import { BookViewerSettings, DEFAULT_SETTINGS } from '../types/settings';

/**
 * 사용자 설정 서비스
 * localStorage를 사용하여 JSON 형식으로 설정을 관리합니다.
 */

const STORAGE_KEY = 'book_viewer_settings';

/**
 * localStorage에서 설정을 가져옵니다.
 */
export const getSettings = (): BookViewerSettings => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      // 기본 설정 저장
      saveSettings(DEFAULT_SETTINGS);
      return DEFAULT_SETTINGS;
    }
    const settings = JSON.parse(stored) as BookViewerSettings;
    // 기본값과 병합하여 누락된 속성 보완
    return { ...DEFAULT_SETTINGS, ...settings };
  } catch (err) {
    // console.error('설정 불러오기 오류:', err);
    return DEFAULT_SETTINGS;
  }
};

/**
 * localStorage에 설정을 저장합니다.
 */
export const saveSettings = (settings: BookViewerSettings): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch (err) {
    // console.error('설정 저장 오류:', err);
  }
};

/**
 * 설정을 업데이트합니다.
 */
export const updateSettings = (updates: Partial<BookViewerSettings>): BookViewerSettings => {
  const currentSettings = getSettings();
  const newSettings = { ...currentSettings, ...updates };
  saveSettings(newSettings);
  return newSettings;
};

/**
 * 설정을 초기화합니다.
 */
export const resetSettings = (): BookViewerSettings => {
  saveSettings(DEFAULT_SETTINGS);
  return DEFAULT_SETTINGS;
};

